import * as React from "react";
import verticalLogo from "../assets/fruitify-vertical.svg";
import horizontalLogo from "../assets/fruitify-horizontal.svg";
import flowerLogo from "../assets/fruitify-flower.svg";

export default function FruitifyLogo({
  flowerOnly = true,
  horizontal = false,
  width = 50,
}) {
  const logo = horizontal
    ? horizontalLogo
    : flowerOnly
      ? flowerLogo
      : verticalLogo;
  return (
    <img src={logo} style={{ width, height: "auto" }} alt="Fruitify logo" />
  );
}
